<template>
  <div class="p-12">
    <div v-if="!isWorking">
      <button v-if="isConnected" @click="logout">Logout</button>
      <button v-if="isConnected" @click="getAccounts">Read Accounts</button>
      <button v-else @click="login">Login</button>
    </div>
  </div>
</template>

<script>
import { loadFbSdk, fbLogin, fbLogout, getFbLoginStatus, fbApi } from '@/utils/facebook';

export default {
  name: 'Settings',

  data() {
    return {
      isWorking: false,
      isConnected: false,
      scope: [
        'ads_management',
        'ads_read',
        'business_management',
        'read_insights',
        'pages_show_list',
        'manage_pages',
      ],
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.isWorking = true;

      try {
        await loadFbSdk('196711961546370', 'v6.0');
        const response = await getFbLoginStatus();
        if (response.status === 'connected') {
          this.isConnected = true;
        }
      } catch (error) {
        //
      } finally {
        this.isWorking = false;
      }
    },

    async login() {
      if (this.isWorking) return;

      this.isWorking = true;

      try {
        const { status } = await fbLogin({ scope: this.scope.toString() });
        if (status === 'connected') {
          this.isConnected = true;
        } else {
          this.isConnected = false;
        }
      } catch (error) {
        /** silence */
      } finally {
        this.isWorking = false;
      }
    },

    async getAccounts() {
      try {
        await fbApi('/me/adaccounts', { fields: 'name' });
      } catch (error) {
        /** errored */
      }
    },

    async logout() {
      if (this.isWorking) return;

      this.isWorking = true;

      try {
        fbLogout();
        this.isWorking = false;
        this.isConnected = false;
      } catch (error) {
        /** errored */
      } finally {
        this.isWorking = false;
      }
    },
  },
};
</script>
